import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { VhQueryAutoWeb, VhAlgorithm } from 'vhautowebdb';
import { Subscription } from 'rxjs';
import { EditNameComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
// import { FunctionService  } from 'vhobjects-service';
// import { EditNameComponent } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';

@Component({
  selector: 'atw-frame-categories-admin',
  templateUrl: './frame-categories-admin.component.html',
  styleUrls: ['./frame-categories-admin.component.scss'],
})

export class AtwFrameCategoriesAdmin implements OnInit {
  @Input() data;

  tableHeight: string; // biến dùng để chứa chiều cao của bảng dữ liệu

  /** Mảng chứa số lượng sản phẩm hiển thị trong 1 trang */
  numberPerPage = [5, 10, 20, 50, 100];
  /** Trang người dùng chuyển tới hiển thị */
  pageGoto: number = 1;
  public subscribe: Subscription;

  /** Mảng chứa danh muc sau khi search trong listCategory */
  public categoryShow: any = [];
  /** Mảng chứa sản phẩm sẽ hiển thị trong block */
  public listCategory: any[];
  /** Tên sản phẩm search trong listCategory */
  public searchNameCategory: string = '';

  /** Tên sản phẩm search trong modal */
  public searchNameCategoryModal: string = '';
  /** Chứa các sản phẩm sau khi search trong shownObjectsModal */
  listCategoryDB = [];
  /** Chứa tất cả sản phẩm hiển thị trong modal */
  listCategoryDBFull = [];

  /** sắp xếp danh sách sản phẩm trong table, true. A->Z, false. Z->A */
  isASC: boolean = true;
  /** sắp xếp danh sách sản phẩm trong modal, true. A->Z, false. Z->A */
  isASCModal: boolean = true;

  /** Giới hạn sản phẩm hiển thị trong block */
  limitBlock: number = 20;
  /** Giới hạn sản phẩm hiển thị trong modal */
  limitModal: number = 20;
  /** Trang hiện tại trong block */
  pageCurrentBlock: number = 1;
  /** Trang hiện tại trong modal */
  pageCurrentModal: number = 1;
  /** Tổng số trang sản phẩm trong block */
  totalPagesBlock: number = 1;
  /** Tổng số trang sản phẩm trong modal */
  totalPagesModal: number = 1;
  /** Số trang hiển thị trong block */
  pageShowChooseBlock: any = [0, 1, 2];
  /** Số trang hiển thị trong modal */
  pageShowChooseModal: any = [0, 1, 2];

  loadingModal = false; // ẩn hiện loading get sp từ DB
  loadingBlock = false; // ẩn hiện loading get sp từ DB

  /** Danh sách sản phẩm khi search block */
  dataSearchedBlock: any = []

  /** Danh sách sản phẩm khi search modal */
  dataSearchedModal: any = []



  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhAlgorithm: VhAlgorithm,
    private routeActiva: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    public functionService: FunctionService,
    private matDialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }


  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId))
      this.subscribe = this.routeActiva.queryParams.subscribe((routeParam) => {
        if (routeParam.page) {
          this.pageCurrentBlock = parseInt(routeParam.page);
          this.sortCategorysBlock();
          this.pageShowChooseBlock = this.pageShowChooseBlock.map((num, index) => {
            return (num = this.pageCurrentBlock + index - 1);
          });
        } else this.sortCategorysBlock();
      });
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId)) {
      this.sortCategorysBlock();
    }
  }


  ngOnDestroy(): void {
    this.subscribe?.unsubscribe();
  }


  trackByFn(index: number, item: any) {
    return item.id; // hoặc sử dụng một thuộc tính duy nhất khác của item
  }


  ngAfterViewChecked() {
    if (isPlatformBrowser(this.platformId))
      if (
        document.querySelector('#purchase-invoice-today') &&
        document.querySelector('.ant-table-thead') &&
        document.querySelector('.purchase-invoice-today-header')
      ) {
        this.tableHeight =
          document.querySelector('#purchase-invoice-today').clientHeight -
          document.querySelector('.ant-table-thead').clientHeight -
          document.querySelector('.purchase-invoice-today-header').clientHeight -
          100 +
          'px';
      }
    this.changeDetectorRef.detectChanges();
  }


  /**
   * Lấy danh mục của block (đã chọn để hiển thị lên block)
   */
  getCategoryOfBlock(sort, pageCurrent) {
    this.loadingBlock = true;
    let query = JSON.parse('{"' + this.data._id + '_hidden":{"$eq": true}}');
    this.vhQueryAutoWeb.getCategorys_byFields(query, {}, sort, this.limitBlock, pageCurrent).then(
      (res: any) => {
        if (res.vcode === 0) {
          this.listCategory = res.data;
          this.categoryShow = this.listCategory;
          this.totalPagesBlock = res.totalpages;
          this.loadingBlock = false;
        }
      },
      (err) => console.error(err)
    );
  }


  /** 
   * Hàm thực hiện cập nhật trạng thái sản phẩm (show_web)
   *
   * @param id
   * @param event
   */
  updateShowWeb(item, value) {
    // nếu value là true thì loading modal sẽ thành true;
    // nếu value là false thì loading block sẽ thành true;
    // this.loadingModal = value ? true : false;
    this.loadingBlock = !value ? true : false;

    let data = {
      [`${this.data._id}_hidden`]: value,
      [this.data._id + '_ordinal_number']: 1,
    };
    item[this.data._id + '_ordinal_number'] = 1
    this.vhQueryAutoWeb.updateCategory(item._id, data).then((bool: any) => {
      // Nếu update thành công
      if (bool) {
        // nếu value là true, tức là thêm vào table các danh mục sẽ hiện lên frame
        if (value) {
          this.listCategory = this.listCategory.concat(item);
          this.categoryShow = this.listCategory
        }
        else {
          // ngược lại xóa khỏi table các danh mục sẽ hiện lên frame
          this.listCategory = this.listCategory.filter(
            (e) => e._id != item._id
          );
          this.categoryShow = this.listCategory
          if (this.listCategory.length === 0) {
            if (this.pageCurrentBlock === this.totalPagesBlock) {
              this.transferFn(this.pageCurrentBlock - 1);
            }
            else {
              this.transferFn(this.pageCurrentBlock);
            }
          }
        }
        // this.onSearchBlock(this.searchNameCategory);
      }

      // this.loadingModal = false;
      this.loadingBlock = false;
    });
  }


  /**
   * Tìm danh mục ở table (search local)
   */
  onSearchBlock(value) {
    this.resetPaginationBlock();
    this.vhQueryAutoWeb.searchList_likeSearch('categorys', 'name_' + this.functionService.defaultLanguage, this.searchNameCategory, { [this.data._id + '_hidden']: { $eq: true } }, {})
      .then((res: any) => {
        console.log('res', res);
        if (res.vcode === 0) {
          this.dataSearchedBlock = res.data.map((e) => {
            return {
              ...e,
              array_step: Array(e.step)
                .fill(0)
                .map((x, i) => i),
            };
          });


          this.categoryShow = this.handlePaginateLocalBlock();
        }
      }, (error: any) => {
        console.log('error', error)
      })

  }

  handlePaginateLocalBlock() {
    let data_filter = this.dataSearchedBlock
    data_filter = this.isASC ? this.vhAlgorithm.sortStringbyASC(data_filter, 'name_' + this.functionService.defaultLanguage) : this.vhAlgorithm.sortStringbyDESC(data_filter, 'name_' + this.functionService.defaultLanguage)
    let data_page = new Array(); //mảng dữ liệu phân theo page
    for (let i = 0; i < data_filter.length; i++) {
      if ((i >= this.limitBlock * (this.pageCurrentBlock - 1)) && (i < this.limitBlock * this.pageCurrentBlock)) data_page.push(data_filter[i]);
    }
    this.totalPagesBlock = Math.ceil(data_filter.length / this.limitBlock); // tổng số page

    return data_page
  }


  /**
   * hàm này reset pagination về 1
   */
  resetPaginationBlock() {
    this.pageCurrentBlock = 1;
    this.pageGoto = 1;
    this.pageShowChooseBlock = [0, 1, 2];
  }


  /* ------------------------- Phân trang trong block ------------------------- */

  /** 
   * Chuyển trang đến trang trước
   */
  gotoPreviousPage() {
    if (this.pageCurrentBlock > 1) {
      this.transferFn(this.pageCurrentBlock - 1);
    } else if (this.pageCurrentBlock == 1) {
      this.transferFn(this.totalPagesBlock);
    }
  }


  /** 
   * Chuyển trang đến trang sau
   */
  gotoNextPage() {
    if (this.pageCurrentBlock < this.totalPagesBlock) {
      this.transferFn(this.pageCurrentBlock + 1);
    } else if ((this.pageCurrentBlock = this.totalPagesBlock)) {
      this.transferFn(1);
    }
  }


  /** 
   * Chuyển đến trang cụ thể
   *
   * @param value trang cần chuyển đến
   */
  transferFn(value: number) {
    this.pageCurrentBlock = Number(value);
    this.pageGoto = Number(value);

    if (this.searchNameCategory && this.dataSearchedBlock.length) {
      this.categoryShow = this.handlePaginateLocalBlock();
    } else this.sortCategorysBlock();

    // Thay đổi giá trị trang cho người dùng chọn
    if (this.pageCurrentBlock < this.totalPagesBlock && this.pageCurrentBlock > 1) {
      this.pageShowChooseBlock = this.pageShowChooseBlock.map((num, index) => {
        return (num = this.pageCurrentBlock + index - 1);
      });
    }
    else {
      this.pageShowChooseBlock = this.pageShowChooseBlock.map((_, index) => this.pageCurrentBlock + index - 1);
    }
  }

  handleSortBlock() {
    this.isASC = !this.isASC;

    if (this.searchNameCategory && this.dataSearchedBlock.length) {
      this.categoryShow = this.handlePaginateLocalBlock();
    } else {
      this.sortCategorysBlock()
    }
  }


  /**
   * Sắp xếp sản phẩm theo thứ tự
   */
  sortCategorysBlock() {
    this.getCategoryOfBlock({ ['name_' + this.functionService.defaultLanguage]: this.isASC ? 1 : -1 }, this.pageCurrentBlock);
  }


  /**
   * Xử lý khi chọn limit sản phẩm hiển thị trong block
   */
  handleChangeLimitBlock() {
    if (this.searchNameCategory) {
      this.resetPaginationBlock();
      this.handlePaginateLocalBlock();
    } else this.transferFn(1);
  }

  /** 
   * Hàm thực hiện cập nhật trạng thái sản phẩm (show_web)
   *
   * @param id
   * @param event
   */
  updateOrder(item, value) {
    this.vhQueryAutoWeb.updateCategory(item._id, { [this.data._id + '_ordinal_number']: value }).then((bool: any) => {
      if (bool.vcode === 0) {

      }
    });
  }


  /**
   * Tìm danh mục trên database (dùng trong modal)
   */
  onSearchModal(value) {

    this.resetPaginationModal();
    this.vhQueryAutoWeb.searchList_likeSearch('categorys', 'name_' + this.functionService.defaultLanguage, this.searchNameCategoryModal, {}, {})
      .then((res: any) => {
        console.log('res', res);
        if (res.vcode === 0) {
          this.dataSearchedModal = res.data;

          this.listCategoryDB = this.handlePaginateLocalModal();
        }
      }, (error: any) => {
        console.log('error', error)
      })
  }

  /**
     * hàm này reset pagination về 1
     */
  resetPaginationModal() {
    this.pageCurrentModal = 1;
    this.pageGoto = 1;
    this.pageShowChooseModal = [0, 1, 2];
  }


  handlePaginateLocalModal() {
    let data_filter = this.dataSearchedModal
    data_filter = this.isASCModal ? this.vhAlgorithm.sortStringbyASC(data_filter, 'name_' + this.functionService.defaultLanguage) : this.vhAlgorithm.sortStringbyDESC(data_filter, 'name_' + this.functionService.defaultLanguage)
    let data_page = new Array(); //mảng dữ liệu phân theo page
    for (let i = 0; i < data_filter.length; i++) {
      if ((i >= this.limitModal * (this.pageCurrentModal - 1)) && (i < this.limitModal * this.pageCurrentModal)) data_page.push(data_filter[i]);
    }
    this.totalPagesModal = Math.ceil(data_filter.length / this.limitModal); // tổng số page

    return data_page
  }


  showModalSelectData = false;
  showModal() {
    this.showModalSelectData = true;
    this.sortCategorysModal();
  }


  /**
   * Lấy danh mục từ database (dùng trong modal)
   * @param sort 
   */
  getCategorysModal(sort, pageCurrent) {
    this.loadingModal = true;
    this.vhQueryAutoWeb
      .getCategorySteps_byIdFatherCategory(
        '',
        {},
        {},
        sort,
        this.limitModal,
        pageCurrent
      )
      .then(
        (rsp: any) => {
          // console.log('rsp', rsp);
          if (rsp.vcode === 0) {
            this.totalPagesModal = rsp.totalpages;

            this.listCategoryDB = rsp.data.map((e) => {
              return {
                ...e,
                array_step: Array(e.step)
                  .fill(0)
                  .map((x, i) => i),
              };
            });

            this.listCategoryDBFull = this.listCategoryDB;
          }
          this.loadingModal = false;
        },
        (error) => {
          console.error(error);
        }
      );
  }


  generateSymBol(array: []) {
    let string = '';
    array.forEach((_) => {
      string = string + `- `;
    });
    return string;
  }


  /* ------------------------- Phân trang trong modal ------------------------- */

  /**
   * Di chuyển đến trang trước trong modal
   */
  gotoPreviousPageModal() {
    if (this.pageCurrentModal > 1) {
      this.transferFnModal(this.pageCurrentModal - 1);
    }
    else if (this.pageCurrentModal == 1) {
      this.transferFnModal(this.totalPagesModal);
    }
  }


  /**
   * Di chuyển đến trang sau trong modal
   */
  gotoNextPageModal() {
    if (this.pageCurrentModal < this.totalPagesModal) {
      this.transferFnModal(this.pageCurrentModal + 1);
    } else if ((this.pageCurrentModal = this.totalPagesModal)) {
      this.transferFnModal(1);
    }
  }


  /**
   * Chuyển đến trang cụ thể trong modal
   * @param pageCurrent trang cần chuyển đến
   */
  transferFnModal(pageCurrent: number) {
    this.pageCurrentModal = Number(pageCurrent);
    this.pageGoto = Number(pageCurrent);

    if (this.searchNameCategoryModal && this.dataSearchedModal.length) {
      this.listCategoryDB = this.handlePaginateLocalModal();
    } else this.sortCategorysModal()

    // Thay đổi giá trị trang cho người dùng chọn
    if (this.pageCurrentModal < this.totalPagesModal && this.pageCurrentModal > 1) {
      this.pageShowChooseModal = this.pageShowChooseModal.map((num, index) => {
        return (num = this.pageCurrentModal + index - 1);
      });
    }
    else {
      this.pageShowChooseModal = this.pageShowChooseModal.map((_, index) => this.pageCurrentModal + index - 1);
    }
  }

  handleChangeCategoryFilterModal() {
    this.totalPagesModal = 1;
    this.listCategoryDB = [];
  }



  /**
   * Lấy danh sách sản phẩm trong modal được sắp xếp theo tên
   */
  sortCategorysModal() {
    if (this.searchNameCategoryModal) {
      this.listCategoryDB = this.handlePaginateLocalModal();
    } else this.getCategorysModal({ ['name_' + this.functionService.defaultLanguage]: this.isASCModal ? 1 : -1 }, this.pageCurrentModal);
  }


  /**
   * Xử lý khi chọn limit sản phẩm hiển thị trong modal
   */
  handleChangeLimitModal() {
    if (this.searchNameCategoryModal) {
      this.resetPaginationModal();
      this.handlePaginateLocalModal();
    } else {
      this.transferFnModal(1);
    }
  }




  /**
   * Hàm mở ra hộp thoại chỉnh sửa tên và update 
   * @param object 
   */
  editNameObject(object: any) {
    this.matDialog
      .open(EditNameComponent, {
        width: '20%',
        data: object.name || this.data.name,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.data.name = result;
          this.updateObject();
        }
      });
  }


  /**
   * Update dữ liệu của 
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.data._id, { name: this.data.name })
      .then((bool) => {
        // console.log('bool', bool);
      },
        (error) => {
          console.log('error', error);
          this.functionService.createMessage('error', 'Cập nhật dữ liệu thất bại !!!');
        }
      );
  }

  handleSortModal() {
    this.isASCModal = !this.isASCModal;

    if (this.searchNameCategoryModal && this.dataSearchedModal.length) {
      this.listCategoryDB = this.handlePaginateLocalModal();
    } else {
      this.sortCategorysModal()
    }
  }

}
